(function () {
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has('sticky-buy-now.js')) return;
    window.Eurus.loadedScript.add('sticky-buy-now.js');
  }

  var YAMPI_CART_ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents, moneyFormat) {
    try {
      var helper = window.Alpine && window.Alpine.store && window.Alpine.store('xHelper');
      if (helper && helper.formatMoney) return helper.formatMoney(cents, moneyFormat);
    } catch (e) {
      /* usa o fallback abaixo */
    }
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function init(root) {
    var configEl = root.querySelector('[data-sbn-config]');
    if (!configEl) return;

    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var variants = {};
    (cfg.variants || []).forEach(function (v) {
      variants[v.id] = v;
    });

    var button = root.querySelector('[data-sbn-buy]');
    var labelEl = root.querySelector('[data-sbn-label]');
    var priceEl = root.querySelector('[data-sbn-price]');
    var compareEl = root.querySelector('[data-sbn-compare]');
    var errorEl = root.querySelector('[data-sbn-error]');
    var busy = false;

    function currentVariant() {
      // Consultado a cada uso porque o tema recria o input ao trocar de variante.
      var input = document.getElementById('update-variant-' + cfg.sectionId);
      var id = input && input.value ? parseInt(input.value, 10) : cfg.defaultVariantId;
      return variants[id] || variants[cfg.defaultVariantId] || null;
    }

    // O bloco de combo controla quantidade e desconto; quando presente, ele é a
    // fonte de verdade para o que deve ir ao checkout.
    function comboState() {
      var el = document.querySelector('.x-combo-block');
      if (!el || !window.Alpine || !window.Alpine.$data) return null;
      try {
        var data = window.Alpine.$data(el);
        return data && data.combo ? data.combo : null;
      } catch (e) {
        return null;
      }
    }

    function quantityInput() {
      return (
        document.querySelector('input[name="quantity"][form="' + cfg.formId + '"]') ||
        document.getElementById('Quantity-atc-' + cfg.sectionId)
      );
    }

    function currentQuantity() {
      var combo = comboState();
      if (combo && combo.qty) return combo.qty;
      var input = quantityInput();
      var qty = input ? parseInt(input.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    function refresh() {
      var variant = currentVariant();
      if (!variant) return;

      var combo = comboState();
      var qty = currentQuantity();
      var disc = combo && combo.disc ? combo.disc : 0;
      var total = variant.price * qty;
      var final = total - Math.round((total * disc) / 100);
      var compare = variant.compare_at_price ? variant.compare_at_price * qty : 0;

      priceEl.textContent = formatMoney(final, cfg.moneyFormat);
      compareEl.textContent = compare > final ? formatMoney(compare, cfg.moneyFormat) : '';

      if (!variant.available) {
        button.disabled = true;
        labelEl.textContent = cfg.soldOutLabel;
      } else if (!busy) {
        button.disabled = false;
        labelEl.textContent = cfg.buyLabel;
      }
    }

    function setBusy(state) {
      busy = state;
      button.classList.toggle('is-loading', state);
      button.disabled = state;
      button.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.classList.add('is-shown');
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-shown');
    }

    function checkoutUrlWithUtms(url) {
      if (typeof window.ymp_getUrlWithUtms === 'function') {
        try {
          return window.ymp_getUrlWithUtms(url);
        } catch (e) {
          return url;
        }
      }
      return url;
    }

    function goToYampiCheckout() {
      if (typeof window.showYampiLoader === 'function') {
        try {
          window.showYampiLoader();
        } catch (e) {
          /* loader é opcional */
        }
      }

      return fetch(routeRoot() + 'cart.json', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          return fetch(YAMPI_CART_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              shop: window.location.host,
              shopify_internal_domain: cfg.shopifyInternalDomain,
              cart_payload: cart
            })
          });
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (resp) {
          if (resp && resp.active && resp.checkout_direct_url) {
            window.location.href = checkoutUrlWithUtms(resp.checkout_direct_url);
            return;
          }
          window.location.href = routeRoot() + 'cart';
        })
        .catch(function () {
          window.location.href = routeRoot() + 'cart';
        });
    }

    function buyNow() {
      if (busy) return;
      var variant = currentVariant();
      if (!variant || !variant.available) return;

      clearError();
      setBusy(true);

      var combo = comboState();
      var item = { id: variant.id, quantity: currentQuantity() };
      if (combo && combo.disc > 0) {
        item.properties = { _combo_discount: combo.disc + '%' };
      }

      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status === 422) {
              throw new Error(data.description || data.message || cfg.errorLabel);
            }
            return data;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          return goToYampiCheckout();
        })
        .catch(function (err) {
          setBusy(false);
          refresh();
          showError((err && err.message) || cfg.errorLabel);
        });
    }

    button.addEventListener('click', buyNow);

    document.addEventListener('eurus:product-page-variant-select:updated:' + cfg.sectionId, refresh);

    // Combo e seletor de quantidade mudam o valor via Alpine, sem disparar
    // eventos nativos — por isso o refresh acontece logo após o clique.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-combo-idx], button[name="plus"], button[name="minus"]')) {
        setTimeout(refresh, 60);
      }
    });
    document.addEventListener('change', function (event) {
      if (event.target.name === 'quantity') refresh();
    });

    setupVisibility(root, cfg);
    refresh();
  }

  // A barra só entra em cena depois que o botão principal de compra sai da tela
  // por cima — assim ela não compete com o CTA original no topo da página.
  function setupVisibility(root, cfg) {
    var anchor =
      document.getElementById('x-atc-button-' + cfg.sectionId) ||
      document.querySelector('.x-combo-block .combo-cta-' + cfg.sectionId) ||
      document.querySelector('.main-product .add_to_cart_button');

    function setVisible(state) {
      root.classList.toggle('is-visible', state);
    }

    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(anchor);
      return;
    }

    var onScroll = function () {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-sbn]').forEach(function (root) {
      if (root.dataset.sbnReady) return;
      root.dataset.sbnReady = 'true';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
